<template>
  <div class="login_out_con">
    <!-- <img class="login_img" src="../assets/bg.png" /> -->
    <div>
      <div class="login_tip_con">开源知识管理工具</div>
      <div class="login_con">
        <div class="login_incon">
          <div class="logo_con">
            <img class="logo_img" src="../assets/logo.png" />
          </div>
          <input
            class="phone_in"
            placeholder="请输入手机号"
            v-model="phoneNumber"
          />

          <div class="code_con">
            <button class="code_btn" :style="{ cursor: cursorStyle }" @click="getCode" :disabled="isDisabled">{{ buttonText }}</button>
            <input class="code_in" placeholder="请输入验证码" v-model="code" />
          </div>

          <button class="login_btn" @click="login">立即登录</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCode } from "@/api/login";

export default {
  name: "login",
  data() {
    return {
      phoneNumber: "",
      code: "",
      verificationCode: "",
      phonePattern: /^1[3-9]\d{9}$/,
      isDisabled: false,
      isCursorDefault: true,
      buttonText: '获取验证码',
      countdown: 60,
      intervalId: null,
      cursorStyle: 'pointer',
    };
  },
  mounted() {
    this.$store.commit("CLEAR_ARTICLE_DATA");
    this.$store.commit("CLEAR_LOCAL_ARTICLE_DATA");
    this.$store.commit("CLEAR_MESSAGE_DATA");
  },
  methods: {
    login() {
      if (!this.phonePattern.test(this.phoneNumber)) {
        this.$alert("请输入正确手机号", "警告", {
          confirmButtonText: "确定",
        });
      } else if (!this.code) {
        this.$alert("请点击获取验证码按钮", "警告", {
          confirmButtonText: "确定",
        });
      } else {
        console.log("===========");
        var that = this;
        
        this.$store
          .dispatch("LoginByPhoneAndCode", {
            phone: that.phoneNumber,
            code: that.code,
          })
          .then((res) => {
            this.$store.dispatch("WhoAmI");
            that.$router.replace({ name: "artcol", params: { refresh: true } });
          });
      }
    },
    getCode() {
      var that = this;
      if(!this.phonePattern.test(this.phoneNumber)){
        this.$alert("请输入正确手机号", "警告", {
          confirmButtonText: "确定",
        });
        return;
      }
      that.isDisabled = true;
      that.cursorStyle = "default"
      that.buttonText = `${that.countdown}秒后重试`;
      that.intervalId = setInterval(() => {
        that.countdown -= 1;
        if(that.countdown <= 0){
          clearInterval(that.intervalId);
          that.cursorStyle = "pointer";
          that.isDisabled = false;
          that.buttonText = '获取验证码';
          that.countdown = 60;
        } else {
          that.buttonText = `${that.countdown}秒后重试`;
        }
      }, 1000);
      getCode(that.phoneNumber).then((res) => {
        if(res.code !== 200){
          this.$message.error(res.msg);
        } else {
          this.$message.success("发送成功");
        }
      })

    },
  },
};
</script>

<style>
.login_tip_con {
  color: white;
  font-size: 45px;
  margin-bottom: 40px;
  font-weight: 600;
  text-align: center;
}

.login_btn {
  width: 100%;
  background-color: #008ef3;
  color: white;
  font-size: 18px;
  margin-top: 30px;
  border: none;
  padding-top: 12px;
  padding-bottom: 12px;
  cursor: pointer;
}

.code_in {
  font-size: 18px;
  padding-left: 20px;
  padding-top: 12px;
  padding-right: 20px;
  padding-bottom: 12px;
  border: 0px;
  background-color: #ffffff;
  opacity: 0.8;
  margin-right: 10px;
  flex-grow: 2;
}

.code_in::placeholder {
  color: #565656;
}

.code_btn {
  background-color: #2683be;
  color: white;
  border: none;
  font-size: 18px;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
  cursor: pointer;
}

.code_con {
  margin-top: 30px;
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
}

.phone_in {
  margin-top: 20px;
  font-size: 18px;
  padding-left: 20px;
  padding-top: 12px;
  padding-right: 20px;
  padding-bottom: 12px;
  width: 380px;
  border: 0px;
  background-color: #ffffff;
  opacity: 0.8;
}

.phone_in::placeholder {
  color: #565656;
}

.login_incon {
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 30px;
  padding-bottom: 30px;
}

.logo_img {
  width: 100px;
}

.logo_con {
  display: flex;
  justify-content: center;
  align-items: center;
}

.login_out_con {
  background-image: url("../assets/bg.png");
  background-repeat: no-repeat;
  background-size: cover;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
}

.login_con {
  z-index: 11;
  background-image: url("../assets/loginbg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.login_img {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 10;
}
</style>